import type { User } from '@auth0/auth0-react'

export const getFullName = (user: User | undefined) => {
  return user
    ? `${user.given_name || ''} ${user.family_name || ''}`.trim() ||
        user.name ||
        ''
    : ''
}

export const getNameInitials = (name: string) => {
  const LETTER_PATTERN = /^[a-z\u00C0-\u017F]/i
  const nameTokens = name
    .toUpperCase()
    .split(/[\s+-]+/)
    .filter(Boolean)
  const tokens = []

  let initials = ''

  // Remove all tokens after the first that starts with a non-letter character
  for (let i = 0; i < nameTokens.length; i++) {
    if (!LETTER_PATTERN.test(nameTokens[i])) {
      break
    }

    tokens.push(nameTokens[i])
  }

  if (tokens.length > 0) {
    initials += tokens[0].substring(0, 1)
  }

  if (tokens.length >= 2) {
    // Find first non-initial
    let foundNonInitial = false

    for (let _i = 1; _i < tokens.length; _i++) {
      if (!tokens[_i].match(/.\./)) {
        foundNonInitial = true
        initials += tokens[_i].substring(0, 1)
        break
      }
    }

    if (!foundNonInitial) {
      initials += tokens[1].substring(0, 1)
    }
  }

  return initials
}
